<template>
  <div class="mt-3">
    <label for="example_answer" class="text-sm font-medium text-gray-700 flex">
      {{ t('slides_editor.components.variant_open_fields.example_answer') }}
    </label>
    <textarea
      v-model="question.variant_attributes.example_answer"
      @input="$emit('onInput')"
      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-black/50"
    />
    <div v-if="errors['section.questions.variant.example_answer']" class="text-red-500 text-sm">{{ errors['section.questions.variant.example_answer'][0] }}</div>

    <div class="flex flex-col gap-2 mt-3">
      <div class="flex items-center gap-1">
        <label class="text-sm font-medium text-gray-700 flex">{{ t('slides_editor.components.variant_open_fields.ideal_answer_length') }}</label>
        <div
          data-controller="tippy"
          :data-tippy-content="t('slides_editor.components.variant_open_fields.ideal_length_tooltip')"
        >
          <InformationCircleIcon class="h-5 w-5 text-gray-700" />
        </div>
      </div>
      <input
        type="number"
        v-model="question.variant_attributes.ideal_length"
        @input="$emit('onInput')"
        class="border border-gray-300 rounded-md p-2"
      />
    </div>
  </div>
</template>

<script setup>
import { InformationCircleIcon } from '@heroicons/vue/24/outline';
import { inject, defineProps } from 'vue'
import { t } from '@/libs/i18n'

const errors = inject('errors')

defineProps({
  question: {
    type: Object,
    required: true
  }
})
</script>
